import { combineReducers } from 'redux'
import { fromJS } from 'immutable'

import app from './app'
import config from './config'
import customTags from './custom_tags'
import dashboard from './dashboard'
import device from './device'
import environment from './environment'
import gaio from './gaio'
import i18n from './i18n'
import identitySets from './identity_sets'
import influencers from './influencers'
import mailingLists from './mailing_lists'
import alerts from './alerts'
import mediaReviews from './media_reviews'
import news from './news'
import pageIdentities from './page_identities'
import publications from './publications'
import savedSearches from './saved_searches'
import statics from './statics'
import subscriptions from './subscriptions'
import user from './user'
import whitelabel from './whitelabel'
import savedDashboard from './saved_dashboard'
import savedCharts from './saved_charts'
import superMenu from './super_menu'
import darknet from './darknet'
import personalSettings from './personal_settings'
import contentDesk from './content_desk'
import contactManagement from './contact_management'
import emailTemplatesLibrary from './email_templates_library'
import notifications from './notifications'
import unsplash from './unsplash'
import anewstip from './anewstip'
import ust from './ust'
import administration from './administration'
import themax from './themax'
import ai from './ai'
import journalists from './journalists'
import home from './home'
import helpCenter from './help_center'
import promptHistory from './prompt_history'
import personaLibrary from './persona_library'

import { logoutRequestSuccess } from '../actions/app'

const appReducer = routerReducer => combineReducers({
  administration,
  ai,
  alerts,
  anewstip,
  app,
  config,
  contactManagement,
  contentDesk,
  customTags,
  darknet,
  dashboard,
  device,
  emailTemplatesLibrary,
  environment,
  gaio,
  helpCenter,
  home,
  i18n,
  identitySets,
  influencers,
  journalists,
  mailingLists,
  mediaReviews,
  news,
  notifications,
  pageIdentities,
  personalSettings,
  promptHistory,
  personaLibrary,
  publications,
  router: routerReducer,
  savedCharts,
  savedDashboard,
  savedSearches,
  statics,
  subscriptions,
  superMenu,
  themax,
  unsplash,
  user,
  ust,
  whitelabel
})

// Pattern inspired by http://stackoverflow.com/questions/35622588/how-to-reset-the-state-of-a-redux-store
const rootReducer = routerReducer => (state, action) => {
  let newState = state

  if (action.type === logoutRequestSuccess().type) {
    // Keep width and height for login page
    newState = {
      environment: state.environment,
      whitelabel: state.whitelabel,
      i18n: state.i18n,
      app: fromJS({
        activeNewsradarId: state.app.get('activeNewsradarId')
      }),
      device: state.device
    }
  }

  return appReducer(routerReducer)(newState, action)
}

// This root reducer is used to create the store
export default rootReducer
